import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';
import { AnalyzerModuleReturn } from 'types';
import { useMemo } from 'react';

export const getAnalyzerModules = async (): Promise<
  AnalyzerModuleReturn[] | undefined
> => {
  const { data }: { data: AnalyzerModuleReturn[] } = await axios.get(
    `/api/analyzer-modules`
  );
  return data as AnalyzerModuleReturn[];
};

type QueryFnType = typeof getAnalyzerModules;

type UseAnalyzerModulesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAnalyzerModules = ({ config }: UseAnalyzerModulesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['analyzerModules'],
    queryFn: () => getAnalyzerModules(),
    ...config,
  });
};

export const useIsBaseEnabled = (analyzerId: number | undefined) => {
  const { data: modules } = useAnalyzerModules({});
  return useMemo(() => {
    if (!analyzerId) return false;
    const associatedModule = modules?.find(
      (module) => module.analyzer_id === analyzerId
    );
    if (!associatedModule) return false;
    return associatedModule.types.some((type) => type === 'BASE');
  }, [modules, analyzerId]);
};

export const useIsGeoEnabled = (analyzerId: number | undefined) => {
  const { data: modules } = useAnalyzerModules({});
  return useMemo(() => {
    if (!analyzerId) return false;
    const associatedModule = modules?.find(
      (module) => module.analyzer_id === analyzerId
    );
    if (!associatedModule) return false;
    return associatedModule.types.some((type) => type === 'GEO');
  }, [modules, analyzerId]);
};

export const useIsTimeshareEnabled = (analyzerId: number | undefined) => {
  const { data: modules } = useAnalyzerModules({});
  return useMemo(() => {
    if (!analyzerId) return false;
    const associatedModule = modules?.find(
      (module) => module.analyzer_id === analyzerId
    );
    if (!associatedModule) return false;
    return associatedModule.types.some((type) => type === 'TIMESHARE');
  }, [modules, analyzerId]);
};
